import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Vendor } from './vendor';
import { VendorService } from './vendor.service';

import {Message,ConfirmationService} from 'primeng/primeng';

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.css'],
  providers: [ConfirmationService]
})
export class VendorComponent implements OnInit {

  vendorList: Vendor[];
  msgs : Message[];
  selectedVendor : Vendor;

  constructor(private vendorService: VendorService, private router: Router,
      private confirmationService: ConfirmationService) {
    this.vendorList = [];
    this.msgs = [];
  }

  ngOnInit() {
    this.loadVendors();
  }

  private loadVendors() {
    this.vendorService.list().subscribe(
      (vendorArray: Vendor[]) => {
        this.vendorList = [];
        for (var vendor of vendorArray)
          this.vendorList = [...this.vendorList, vendor];
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of vendors.' });
      }
    );
  }

  public addNew() {
    console.log('Navigate to new Vendor component.');
    this.router.navigateByUrl('/vendor/new');
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
    if (this.selectedVendor == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Keine Lieferant ausgewaehlt.' });
      return;
    }

    this.router.navigate(['/vendor', this.selectedVendor.id])
  }

  public deleteSelected() {
    this.msgs = [];
    if (this.selectedVendor == null) {
      this.msgs.push({ severity: 'info', summary: 'Keine Lieferant ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Moechten Sie den Lieferant wirlich loeschen?',
      accept: () => {
        this.vendorService.delete(this.selectedVendor.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Lieferant wurde geloescht.' });
              this.loadVendors();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Lieferant konnte nicht geloescht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Lieferant konnte nicht geloescht werden.' });
            console.log(err);
          }
        );
      }
    });

  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/vendor/vendor.component.ts